<template>
  <div class="md-layout text-center login-fix-page">
    <div class="md-layout-item md-size-100">
      <div class="text-center">
        <h3 style="font-weight: bold; font-size: 40px">Log in</h3>
      </div>
    </div>

    <div class="loginBorder">
      <form @submit.prevent="login">
        <div style="display: flex; border-bottom: solid">
          <i
            style="color: #8cc63f; padding: 15px; font-size: 26px"
            class="fa fa-envelope"
          ></i>
          <input
            class="col-10"
            required
            v-model="username"
            type="text"
            placeholder="Email..."
            style="
              border: none;
              margin-left: 5px;
              padding: 15px;
              background: transparent;
            "
          />
        </div>
        <div style="display: flex; margin-top: 10px; border-bottom: solid">
          <i
            style="color: #8cc63f; padding: 15px; font-size: 26px"
            class="fa fa-lock"
          ></i>
          <input
            class="col-10"
            required
            v-model="password"
            type="password"
            placeholder="Password..."
            style="
              border: none;
              margin-left: 5px;
              padding: 15px;
              background: transparent;
            "
          />
        </div>
        <button
          slot="footer"
          type="submit"
          style="
            border: 2px solid rgb(140, 198, 63);
            margin-top: 50px;
            padding: 6px 24px;
            border-radius: 6px;
            font-weight: bold;
            color: rgb(140, 198, 63);
            background: transparent;
          "
        >
          Log in
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import sweetAlert from "sweetalert2";

export default {
  components: {},

  data() {
    return {
      username: "",
      password: "",
      disableLogin: false,
    };
  },
  methods: {
    login() {
      this.disableLogin = false;
      this.formValidation();
      if (!this.disableLogin) {
        this.$store
          .dispatch("loginUser", {
            localStorage: this.$localStorage,
            store: this.$store,
            username: this.username,
            password: this.password,
          })
          .then(() => {
            // console.log("Error", this.loginError)
            if (this.loginError) {
              sweetAlert({
                title: "Error",
                text: "Please make sure you have the right credentials",
                type: "error",

                confirmButtonText: "Return",
              });
            }
          });
      }
    },
    formValidation() {
      if (!this.username || !this.password) {
        this.disableLogin = true;
        sweetAlert({
          title: "Error",
          text: "Please make sure to fill your username & password",
          type: "error",

          confirmButtonText: "Return",
        });
      }
    },
  },
  computed: {
    ...mapState({
      loginError: (state) => state.userStore.error_msg,
    }),
  },
  watch: {
    loginError(current) {
      if (current) {
        sweetAlert({
          title: "Error",
          text: "Please make sure you have the right credentials",
          type: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>

<style scoped>
.login-fix-page {
  padding-bottom: 7em;
  padding-top: 4em;
}

@media (min-width: 641px) {
  .loginBorder {
    border: solid;
    border-width: 7px;
    border-radius: 20px;
    border-top: none;
    border-color: rgb(140, 198, 63);
    padding: 55px;
  }
}

@media (max-width: 576px) {
  .loginBorder {
    border: solid;
    border-width: 7px;
    border-radius: 20px;
    border-top: none;
    border-color: rgb(140, 198, 63);
    padding: 25px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/login.vue